import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  FLAG_GETTING_CARGO_ITEMS,
  GET_CARGO_ITEMS,
  CLEAR_CARGO_ITEM,
  FLAG_CARGO_ITEM_ACTIVITY,
  GET_CARGO_ITEM,
  CLEAR_CARGO_ITEMS,
  CLEAR_CARGO_ITEM_DETAIL,
  GET_CARGO_ITEM_DETAIL,
} from '../../../actions/types/cargo';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
    detail: Immutable.Map(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_CARGO_ITEMS:
      return state.setIn(['all', 'loading'], payload);
    case GET_CARGO_ITEMS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_CARGO_ITEMS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_CARGO_ITEM_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_CARGO_ITEM:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_CARGO_ITEM:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    case GET_CARGO_ITEM_DETAIL:
      return state.setIn(['current', 'detail'], Immutable.Map(payload));
    case CLEAR_CARGO_ITEM_DETAIL:
      return state.setIn(
        ['current', 'detail'],
        INITIAL_STATE.getIn(['current', 'detail']),
      );
    default:
      return state;
  }
};
